export default __webpack_public_path__ + "8f03403da052493d0301c74936a79b68.png";